// Wording for the "Connect your QuickBooks account" banner on the Dashboard.
// Only say "demo data" when the app is really showing sample data.
export function qbBannerMessage(dataSource) {
  if (dataSource === "mock") {
    return "You're currently viewing demo data. Connect QuickBooks to see your real job profitability numbers.";
  }
  return "Connect QuickBooks to keep these numbers up to date automatically.";
}
